Admin = require './containers/Admin'
React = require 'react'
{ Route, IndexRoute, IndexRedirect } = require 'react-router'
{ routeActions } = require 'redux-simple-router'

{ doFlash } = require './actions/flash'
{ authTools } = require '../../shared/js/lib/authTools'

App = require './containers/App'
Export = require './containers/Export'
GoldStandardObservations = require './containers/GoldStandardObservations'
HistoricalScores = require './containers/HistoricalScores'
InProgressObservations = require './containers/InProgressObservations'
Login = require './containers/Login'
Logout = require './containers/Logout'
Observation = require './containers/Observation'
ObservationDashboard = require './containers/ObservationDashboard'
ObservationScores = require './containers/ObservationScores'
ObservationSetup = require './containers/ObservationSetup'
ReliabilityObservationSetup = require './containers/ReliabilityObservationSetup'
{ GLOBAL_ADMIN } = require '../../shared/js/lib/roles'


module.exports = (store) ->
	redirectIfNotLoggedIn = (nextState, replace) ->
		return if window.location.pathname == '/login' || window.location.pathname == '/logout'
		user = store.getState().auth.user
		replace({ pathname: '/login' }) unless user

	onlyGlobalAdminsAllowed = (nextState, replace) ->
		user = store.getState().auth.user
		return unless user
		unless authTools.hasRoleOfAtLeast(GLOBAL_ADMIN, user)
			store.dispatch doFlash 'error', 'Error!', "You are not authorized to access this content"
			replace pathname: '/'

	React.createElement(Route, {"path": "/", "component": (App), "onEnter": ( redirectIfNotLoggedIn )},
		React.createElement(IndexRoute, {"component": (ObservationDashboard)}),
		React.createElement(Route, {"path": "/dashboard", "component": (ObservationDashboard)}),
		React.createElement(Route, {"path": "/dashboard/:observationId", "component": (ObservationDashboard)}),
		React.createElement(Route, {"path": "/dashboard/:observationId/:section", "component": (ObservationDashboard)}),
		React.createElement(Route, {"path": "/dashboard/:observationId/students/:studentId", "component": (ObservationDashboard)}),
		React.createElement(Route, {"path": "observations"},
			React.createElement(IndexRedirect, {"to": "/"}),
			React.createElement(Route, {"path": "new", "component": (ObservationSetup)}),
			React.createElement(Route, {"path": "reliability", "component": (ReliabilityObservationSetup)}),
			React.createElement(Route, {"path": "in_progress", "component": (InProgressObservations)}),
			React.createElement(Route, {"path": ":current", "component": (Observation)}),
			React.createElement(Route, {"path": ":observationId/scores", "component": (ObservationScores)})
		),
		React.createElement(Route, {"path": "reports"},
			React.createElement(IndexRedirect, {"to": "export"}),
			React.createElement(Route, {"path": "export", "component": (Export)})
		),
		React.createElement(Route, {"path": "admin", "onEnter": ( onlyGlobalAdminsAllowed )},
			React.createElement(Route, {"path": "standards", "component": ( GoldStandardObservations )})
		),
		React.createElement(Route, {"path": "scores", "component": ( HistoricalScores )}),
		React.createElement(Route, {"path": "login", "component": (Login)}),
		React.createElement(Route, {"path": "logout", "component": (Logout)})
	)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/routes.cjsx